import React from 'react';
import { IconSvgProps } from '@models/common';

const PlagiarismCheck: React.FC<IconSvgProps> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      viewBox='0 0 25 24'>
      <path
        fill='currentColor'
        d='M5.95 19V5c0-.4.146-.604.295-.726.183-.15.435-.224.634-.224H18.1a.95.95 0 0 1 .951.95v6.2a1.05 1.05 0 1 0 2.1 0V5a3.05 3.05 0 0 0-3.05-3.05H6.88c-.628 0-1.365.208-1.965.7C4.281 3.169 3.85 3.966 3.85 5v14a3.05 3.05 0 0 0 3.05 3.05h2.2a1.05 1.05 0 1 0 0-2.1H6.9a.95.95 0 0 1-.95-.95'
      />
      <path
        fill='currentColor'
        d='M8.893 8.852a1.05 1.05 0 1 1 0-2.1h6.904a1.05 1.05 0 1 1 0 2.1zM8.893 13.05a1.05 1.05 0 0 1 0-2.1h.976a1.05 1.05 0 1 1 0 2.1zM16.674 16.252a1.744 1.744 0 1 0-3.487 0 1.744 1.744 0 0 0 3.487 0m2.4 0c0 .707-.178 1.373-.49 1.956l1.822 1.82a1.201 1.201 0 0 1-1.698 1.699l-1.822-1.823a4.144 4.144 0 1 1 2.188-3.653'
      />
    </svg>
  );
};

export default PlagiarismCheck;
